import axios from "axios";

import { SERVER_API_URL } from "@/constants";
const user = JSON.parse(localStorage.getItem("user"));

const TIMEOUT = 1000000;
const onRequestSuccess = (config) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (!config.url.includes("/auth/login")) {
    if (user == null || (user && user.expiDate < new Date())) {
      localStorage.removeItem("user");
      let loc = window.location;
      loc.href = window.location.origin + "/Login";
    } else {
      user.expiDate = new Date().setHours(new Date().getHours() + 12);
      localStorage.setItem("user", JSON.stringify(user));
    }
  }
  axios.defaults.headers = {
    "X-Username": user ? user.username : "",
  };
  config.timeout = TIMEOUT;
  config.url = `${SERVER_API_URL}${config.url}`;
  return config;
};
const setupAxiosInterceptors = (onUnauthenticated) => {
  const onResponseError = (err) => {
    const status = err.status || err.response.status;
    if (status === 401) {
      console.log("status 401");
      // history.pushState({}, null, '/Login');
      // location.reload();
      // onUnauthenticated();
    }
    return Promise.reject(err);
  };
  if (axios.interceptors) {
    axios.interceptors.request.use(onRequestSuccess);
    axios.interceptors.response.use((res) => res, onResponseError);
  }
};

export { onRequestSuccess, setupAxiosInterceptors };
